/*
  Apply global css styles here
 */

import { GlobalStyles as MuiGlobalStyles } from '@mui/material'

const GlobalStyles = () => (
  <MuiGlobalStyles
  // styles={{
  //   '*': {
  //     boxSizing: 'border-box',
  //     margin: 0,
  //     padding: 0,
  //   },
  //   html: {
  //     '-webkit-font-smoothing': 'antialiased',
  //     '-moz-osx-font-smoothing': 'grayscale',
  //     height: '100%',
  //     width: '100%'
  //   },
  //   body: {
  //     height: '100%',
  //     width: '100%'
  //   },
  //   '#root': {
  //     height: '100%',
  //     width: '100%'
  //   }
  // }}
  />
)

export default GlobalStyles
